<!--
  SettingsPage · 播放设置页（路由 /settings）
  - 直接复用 SettingsPanel 组件（学习模式预设管理）
  - 预设改动通过全局 state 生效，PlayerPage 加载时会读取
-->
<template>
  <div class="settings-page">
    <div class="page-head">
      <h2>⚙️ 播放设置</h2>
    </div>
    <SettingsPanel @apply="onApplied" />
  </div>
</template>

<script setup>
import SettingsPanel from '@/components/SettingsPanel.vue'
import { toast } from '@/composables/usePlayerState'

function onApplied() {
  // 预设已写入全局 state，PlayerPage 加载时会读取 syncPlaybackRateToPreset
  // 这里只在设置页给个提示
  toast('预设已更新，下次进入播放器生效')
}
</script>

<style scoped>
.settings-page { display: flex; flex-direction: column; gap: 12px; }
.page-head h2 { margin: 0; font-size: 22px; }
/* SettingsPanel 是 details，在这里占满宽度 */
:deep(.adv) { padding: 16px; }
</style>
